"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const ChooseScenario_vue_1 = tslib_1.__importDefault(require("../confirmIdentity/ChooseScenario.vue"));
const ElementIds_1 = require("../../enums/ElementIds");
exports.default = vue_1.default.extend({
    name: 'forgot-username-choose-scenario',
    components: {
        ChooseScenario: ChooseScenario_vue_1.default,
    },
    computed: {
        elementIds: () => ElementIds_1.ElementIds,
    },
});
